const etkinlikArr = [
    {
        src: '/assets/etkinlikler/etkinlik-1.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/atolye-1.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/etkinlik-2.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/atolye-2.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/etkinlik-3.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/atolye-3.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/etkinlik-4.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/atolye-4.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/etkinlik-5.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/atolye-5.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/etkinlik-6.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/atolye-6.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/etkinlik-7.jpg?v=1'
    },
    {
        src: '/assets/etkinlikler/atolye-7.jpg?v=1'
    }
  ];

export { etkinlikArr };